import { HttpContextToken } from '@angular/common/http';
import { environment } from '../../../environments/environment';

/** Somente a tela de entrada assume a apresentação dos erros dessas operações. */
export const ERRO_ENTRADA_TRATADO = new HttpContextToken<boolean>(() => false);

export function urlApi(url: string, origem: string): URL | null {
  try {
    const base = new URL(`${environment.apiUrl.replace(/\/$/, '')}/api/`, origem);
    const destino = new URL(url, origem);
    return destino.origin === base.origin && destino.pathname.startsWith(base.pathname) ? destino : null;
  } catch {
    return null;
  }
}

export function chamadaEntrada(url: string, origem: string): boolean {
  const destino = urlApi(url, origem);
  if (!destino) return false;
  const base = new URL(`${environment.apiUrl.replace(/\/$/, '')}/api/`, origem);
  return destino.pathname === `${base.pathname}acesso/entrada`
    || destino.pathname === `${base.pathname}acesso/entrada/credenciais`;
}
